import { WorkOrderPriceDto } from "../models/WorkOrderPriceDto";
import BaseController from "../pages/sharedControllers/BaseController";
import { WorkOrderItemWithPrices } from "../models/WorkOrderItemWithPrices";
import JSONModel from "sap/ui/model/json/JSONModel";
import { MainContractOptionDto } from "../models/MainContractOptionDto";

export async function CheckMainContract(
  controller: BaseController,
  contract: MainContractOptionDto | undefined,
  workOrderId: string | undefined = undefined
) {
  if (!contract) return;

  const existingWorkOrders = await controller.get<WorkOrderPriceDto[]>(
    "api/WorkOrder/GetExistingWorkOrdersForMainContract",
    {
      params: {
        contractId: contract.contractId,
        currentWorkOrderId: workOrderId,
      },
    }
  );

  if (existingWorkOrders.length > 0) {
    const dialog = await controller.openDialog(
      "akademika.akamont.pages.workOrderDetailsInternal.WarningAboutExistingWorkOrdersForSameMainContractDialog",
      true
    );
    dialog.setModel(
      new JSONModel({
        existingWorkOrders: existingWorkOrders,
        title: await controller.translateWithParams('workOrdersExistForContract', [contract.sapId, contract.buyerName]),
      })
    );
  }
}

export async function CheckWorkOrderItemService(
  controller: BaseController,
  contractId: string | undefined,
  serviceMeasurementUnitId: string | undefined,
  serviceText: string | undefined,
  workOrderId: string | undefined
) {
  if (!contractId || !serviceMeasurementUnitId) return;

  const existingWorkOrderItems = await controller.get<
    WorkOrderItemWithPrices[]
  >("api/WorkOrder/GetExistingWorkOrderItemsForMainContract", {
    params: {
      contractId: contractId,
      currentWorkOrderId: workOrderId,
      serviceMeasurementUnitId: serviceMeasurementUnitId,
    },
  });

  if (existingWorkOrderItems.length > 0) {
    const dialog = await controller.openDialog(
      "akademika.akamont.pages.workOrderDetailsInternal.WarningAboutExistingItemsForSameMainContractDialog",
      true
    );
    dialog.setModel(
      new JSONModel({
        serviceText: serviceText,
        existingWorkOrderItems: existingWorkOrderItems,
      })
    );
  }
}
